import {capitalCase} from 'change-case'
import {errors} from 'constants/forms'
import {useSearchParams} from 'react-router-dom'

export const isNew = (itemId) => !itemId || itemId === 'new'

export const useDuplicateFromId = (id) => {
    const [searchParams] = useSearchParams()
    if (!isNew(id)) {
        return null
    }
    return searchParams.get('duplicateFrom')
}

export const useDuplicateFormId = (id) => useDuplicateFromId(id)

export const getDuplicatedItemData = (item) => {
    if (!item) return item
    const {_id, ...rest} = item
    return rest
}

export const extractError = (saveError, createError) =>
    saveError?.data?.message || createError?.data?.message

export const getFormTitle = (itemId, itemName) => {
    let action = 'Update'
    if (isNew(itemId)) {
        action = 'Create'
    }
    return `${action} ${capitalCase(itemName)}`
}

export const getItemLabel = (itemKey, itemName) => {
    if (itemKey === 'name') {
        return `${capitalCase(itemName)} Name`
    }
    return capitalCase(itemKey)
}

export const getShouldShowItemKey = (item, itemKey, disabled) =>
    !!item?.[itemKey] || item?.[itemKey] === false || !disabled

export const getFormError = (error, itemKey, i18n) => {
    const duplicateKeyError = i18n.t('formErrors.duplicateKey', {
        key: itemKey,
    })

    return error.includes(errors.duplicateKey)
        ? duplicateKeyError
        : i18n.t('formErrors.somethingWentWrong')
}
